import { render, staticRenderFns } from "./AdminSnippetsTable.vue?vue&type=template&id=7b67abf0&scoped=true"
import script from "./AdminSnippetsTable.vue?vue&type=script&lang=js"
export * from "./AdminSnippetsTable.vue?vue&type=script&lang=js"
import style0 from "./AdminSnippetsTable.vue?vue&type=style&index=0&id=7b67abf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b67abf0",
  null
  
)

export default component.exports